import variantStorage from './variantStorage';
import { ROUTES } from '../constants/routes';
import carUrlQueryTransformer from './carUrlQueryTransformer';
import urlRoute from './urlRoute';
import { IBuiltCar } from '../../../../common/model/IBuiltCar';
import { QUERY_KEYS } from '../constants/queryKeys';

const carRouteHelper = {
  getConfigureRoute(modelId: string, variantId: string, carId: string): { pathname: string; search: string } {
    let selectedVariantId = variantStorage.getSelectedVariantId(modelId);

    if (!selectedVariantId) {
      selectedVariantId = variantId;
    }

    const customisedCar = variantStorage.getCustomisedCar(selectedVariantId);

    if (customisedCar) {
      return {
        pathname: urlRoute.createUrl(ROUTES.CONFIGURE, { modelId, carId: customisedCar.carId }),
        search: carUrlQueryTransformer.toQueryString(customisedCar),
      };
    }

    return {
      pathname: urlRoute.createUrl(ROUTES.CONFIGURE, { modelId, carId }),
      search: '',
    };
  },

  getConfigureVariantRoute(modelId: string): { pathname: string } {
    return {
      pathname: `${ROUTES.VARIANTS_BASE}${modelId}`,
    };
  },
  getConfigurationSourceUrl(modelId: string, car: IBuiltCar, widgetBasePath = ''): string {
    const configurePath = urlRoute.createUrl(ROUTES.CONFIGURE, { modelId, carId: car.carId });
    const query = carUrlQueryTransformer.toQueryString(car);
    const baseUrl = urlRoute.joinUrl(location.origin, widgetBasePath, configurePath);

    return baseUrl + `?${QUERY_KEYS.OPEN_CUSTOMISATION}=1&` + query;
  },
};

export default carRouteHelper;
